import React from 'react';
import { heroFacts, heroLead } from '../data/company';
import { renderRich } from '../utils/richText';
import { ButtonLink } from './ButtonLink';
export function Hero() {
  return <section className="border-b border-line pb-[52px] pt-12 md:pt-16" aria-labelledby="hero-title" data-id="element-44" data-mp="9kjvumdkz02m">
      <div className="mx-auto max-w-[1080px] px-[22px]" data-id="element-45" data-mp="4lywep65kkf8">
        <p className="mb-5 inline-block rounded-full border border-accent-soft/40 bg-accent/[0.08] px-[13px] py-1.5 text-[11.5px] font-bold uppercase tracking-[0.09em] text-accent-soft" data-id="element-46" data-mp="4njq6ckn7zc1">
          Massive Faith LLC · Wyoming, Estados Unidos
        </p>
        <h1 id="hero-title" className="mb-[18px] max-w-[900px] text-[29px] font-extrabold leading-[1.13] tracking-[-0.03em] text-fg sm:text-[38px] md:text-[49px]" data-id="element-47" data-mp="sai4b3laiv6s">
          Libros digitales para chicos de 6 a 12 años, con entrega inmediata.
        </h1>
        <p className="mb-[26px] max-w-[790px] text-base leading-relaxed text-muted md:text-[19px]" data-id="element-48" data-mp="382p4d9lap7jk">{renderRich(heroLead)}</p>
        <div className="mb-[34px] flex flex-wrap gap-3" data-id="element-49" data-mp="3j9kalakrlffl">
          <ButtonLink href="#soporte" data-id="element-50" data-mp="3o7lshs6gf8ph">Contactar con atención al cliente</ButtonLink>
          <ButtonLink href="#reembolsos" variant="ghost" data-id="element-51" data-mp="3o5j2v997rhla">
            Ver política de reembolsos
          </ButtonLink>
        </div>
        <dl className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-52" data-mp="3e963pvuwgbj5">
          {heroFacts.map(fact => <div key={fact.label} className="rounded-xl border border-line bg-surface px-[17px] py-[15px]" data-id="element-53" data-mp="30gzwiz9q5evu">
              <dt className="mb-1 text-[11px] font-bold uppercase tracking-[0.08em] text-muted" data-id="element-54" data-mp="359j9pv4i2804">{fact.label}</dt>
              <dd className="break-words text-[14.5px] font-semibold text-fg" data-id="element-55" data-mp="2qleq8oxmhsga">{fact.value}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}